<template>
  <div id="calendar">
    <div class="title">
      <img src="../assets/right10.png" class="arrow"
        @click="changeMonth('pre')" />
      <!-- <div class="year-month">{{ currentYear }}year{{ currentMonth }}month</div> -->
      <div class="year-month">Date {{ currentYear }}-{{ currentMonth }}</div>
      <img src="../assets/left10.png" class="arrow"
        @click="changeMonth('next')" />
    </div>
    <ul class="weekdays">
      <li v-for="(val, key) in weeks">{{ val }}</li>
    </ul>
    <ul class="days">
      <li v-for="(val, key) in days" :class="chooseClass(val)"
        @click="getShow(val, key)">
        <span class="time">{{ val.day.getDate() }}</span>
        <span class="text" v-if="val.num == 0 && !val.show">Free</span>
        <span class="text" v-if="val.num == 1 && !val.show">Work</span>
        <span class="text" v-if="val.num == 2 && !val.show">Rest</span>
        <span class="text" v-if="val.show">Select</span>
      </li>
    </ul>
    <div class="hisDate-btn" @click="subimt">Clear date</div>
  </div>
</template>

<script>
export default {
  name: "calendar",
  props: {
    gzList: {
      type: String,
      default: "",
    },
    xxList: {
      type: String,
      default: "",
    },
    yxList: {
      type: Array,
      default: [],
    },
  },
  data () {
    return {
      currentDay: 1,
      currentMonth: 1,
      currentYear: 1970,
      currentWeek: 1,
      weeks: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      days: [],
      lists: [],
    };
  },
  created () {
    this.init();
  },
  watch: {
    gzList: {
      handler () {
        this.aaa();
      },
      immediate: true,
    },
    days: {
      handler () {
        this.aaa();
      },
      immediate: true,
    },
  },
  methods: {
    aaa () {
      // 工作
      for (let i = 0; i < this.days.length; i++) {
        for (let j = 0; j < this.gzList.split(",").length; j++) {
          if (this.parseTime(this.days[i].day) == this.gzList.split(",")[j]) {
            this.days[i].num = 1;
          }
        }
      }
      // 休息
      for (let k = 0; k < this.days.length; k++) {
        for (let v = 0; v < this.xxList.split(",").length; v++) {
          if (this.parseTime(this.days[k].day) == this.xxList.split(",")[v]) {
            this.days[k].num = 2;
          }
        }
      }
      // 已选
      for (let m = 0; m < this.yxList.length; m++) {
        for (let n = 0; n < this.days.length; n++) {
          if (this.parseTime(this.days[n].day) == this.yxList[m].day) {
            this.days[n].show = true;
            this.days[n].num = 0;
          }
        }
      }
      this.days.forEach((item) => {
        if (item.show) {
          this.lists.push({
            day: this.parseTime(item.day),
            num: item.num,
            show: item.show,
          });
        }
      });
      this.$emit("val", this.lists);
    },
    vvv (str) {
      if (str < 10) {
        return "0" + str;
      } else {
        return str;
      }
    },
    getShow (val, i) {
      if (this.currentMonth != val.day.getMonth() + 1) {
        return;
      }
      if (this.days[i].num != 0) {
        return;
      }
      let time = new Date();
      let yyyy1 =
        time.getFullYear() +
        "" +
        this.vvv(time.getMonth() + 1) +
        "" +
        this.vvv(time.getDate());
      let yyyy2 =
        val.day.getFullYear() +
        "" +
        this.vvv(val.day.getMonth() + 1) +
        "" +
        this.vvv(val.day.getDate());
      if (yyyy2 >= yyyy1) {
        this.days[i].show = true;
      } else {
        this.$message({
          message: "Please select a date today or after today",
          type: "error",
          center: true,
          duration: 2000,
        });
        return;
      }
      let find = this.lists.find((item) => {
        return item.day == this.parseTime(val.day);
      });
      if (!find) {
        this.lists.push({
          day: this.parseTime(val.day),
          num: val.num,
          show: val.show,
        });
      }
      this.$emit("val", this.lists);
    },
    init (data) {
      let day;
      if (data) {
        day = new Date(data);
      } else {
        let now = new Date();
        day = new Date(this.formDate(now.getFullYear(), now.getMonth() + 1, 1));
      }
      this.currentDay = day.getDate();
      this.currentYear = day.getFullYear();
      this.currentMonth = day.getMonth() + 1;
      this.currentWeek = day.getDay();
      if (!this.currentWeek) {
        this.currentWeek = 7;
      }
      this.days = [];
      let str = this.formDate(
        this.currentYear,
        this.currentMonth,
        this.currentDay
      );
      for (let i = 2 - this.currentWeek; i < 44 - this.currentWeek; i++) {
        let d = new Date(str);
        d.setDate(i);
        this.days.push({
          day: d,
          num: 0,
          show: false,
        });
      }
    },

    //其他月加class名'other'
    chooseClass (val) {
      if (
        val.day.getMonth() + 1 != this.currentMonth &&
        val.num == 0 &&
        !val.show
      ) {
        return "other";
      } else if (
        val.day.getMonth() + 1 != this.currentMonth &&
        val.num == 1 &&
        !val.show
      ) {
        return "other gz";
      } else if (
        val.day.getMonth() + 1 == this.currentMonth &&
        val.num == 1 &&
        !val.show
      ) {
        return "gz";
      } else if (
        val.day.getMonth() + 1 != this.currentMonth &&
        val.num == 0 &&
        val.show
      ) {
        return "other yx";
      } else if (
        val.day.getMonth() + 1 == this.currentMonth &&
        val.num == 0 &&
        val.show
      ) {
        return "yx";
      } else if (
        val.day.getMonth() + 1 != this.currentMonth &&
        val.num == 2 &&
        !val.show
      ) {
        return "other xx";
      } else if (
        val.day.getMonth() + 1 == this.currentMonth &&
        val.num == 2 &&
        !val.show
      ) {
        return "xx";
      }
    },
    //切换月份
    changeMonth (a) {
      let d = new Date(this.formDate(this.currentYear, this.currentMonth, 1));
      // setDate(0); 上月最后一天
      // setDate(-1); 上月倒数第二天
      // setDate(n) 参数n为 上月最后一天的前后n天
      a === "pre" ? d.setDate(0) : d.setDate(35);

      this.init(this.formDate(d.getFullYear(), d.getMonth() + 1, 1));
    },
    //返回字符串个格式的日期
    formDate (year, month, day) {
      return year + "-" + month + "-" + day;
    },
    // 转换标准时间为YYYY-MM-DD格式
    parseTime (str) {
      if ((str + "").indexOf("-") != -1) {
        str = str.replace(new RegExp(/-/gm), "/");
      }
      let d = new Date(str);
      let newDateYear = d.getFullYear();
      let newDateMonth =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      let newDateDay =
        d.getDate() + "" < 10 ? "0" + d.getDate() + "" : d.getDate() + "";
      return newDateYear + "-" + newDateMonth + "-" + newDateDay;
    },
    // 清楚日期
    subimt () {
      this.days.forEach((item) => {
        if (item.show) {
          item.show = false;
        } else {
          item.show = false;
        }
      });
      this.lists = [];
      this.$emit("val", []);
    },
  },
};
</script>

<style lang="scss" scoped>
#calendar {
  width: 100%;
  padding: 0 76px;
  box-sizing: border-box;
}

.title {
  padding: 28px 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .arrow {
    display: block;
    width: 50px;
    height: 50px;
  }
  .year-month {
    color: #00fff0;
    font-size: 20px;
  }
}
.weekdays {
  display: flex;
  justify-content: space-between;
  align-items: center;
  li {
    flex: 1;
    text-align: center;
    color: #ffffff;
    text-align: center;
    padding: 12px 0;
    font-weight: 400;
    box-sizing: border-box;
  }
}

.days {
  display: flex;
  flex-wrap: wrap;
  li {
    width: 14.28%;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    .time {
      display: inline-block;
      width: 30px;
      height: 30px;
      font-size: 20px;
      color: #ffffff;
      border-radius: 50%;
      text-align: center;
      line-height: 30px;
    }
    .text {
      margin-top: 5px;
      color: #ffffff;
    }
  }
  .other {
    .time {
      color: #767676;
    }
    .text {
      color: #767676;
    }
  }
  .gz {
    .time {
      background: #ff511b;
      color: #ffffff;
    }
    .text {
      color: #ff511b;
    }
  }
  .xx {
    .time {
      background: #10b962;
      color: #ffffff;
    }
    .text {
      color: #10b962;
    }
  }
  .yx {
    .time {
      background: #18cfca;
      color: #ffffff;
    }
    .text {
      color: #18cfca;
    }
  }
}
.hisDate-btn {
  width: 379px;
  height: 60px;
  background: linear-gradient(
    90deg,
    rgba(26, 175, 170, 0.8) 0%,
    rgba(29, 255, 247, 0.8) 100%
  );
  font-size: 24px;
  font-weight: bold;
  color: #f6f6f6;
  line-height: 60px;
  text-align: center;
  margin: 27px auto 20px;
}
</style>
